Handlebars.registerPartial('devPoolCountryPartial', require('gdpc-console/dev-pool-country-item-template'))
Handlebars.registerPartial('localeOptions', require('lib/locale-options-template'))
